(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ProfileCore", [], factory);
	else if(typeof exports === 'object')
		exports["ProfileCore"] = factory();
	else
		root["ProfileCore"] = factory();
})(this, () => {
return 